module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_harei-ccf4a15b591bcfe28e76b100b499b22c.png";